import { createQuery } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

export const GetResourceAgendaPublicBoardSchema = z.object({
  slug: z.string(),
  board_id: z.number(),
  board_name: z.string(),
  is_entity_detail_sharing_allowed: z.boolean()
});

type GetResourceAgendaPublicBoard = z.infer<
  typeof GetResourceAgendaPublicBoardSchema
>;

const GetResourceAgendaPublicBoardRequestSchema = z.object({
  slug: z.string()
});

type GetResourceAgendaPublicBoardRequest = z.infer<
  typeof GetResourceAgendaPublicBoardRequestSchema
>;

export const useGetResourceAgendaPublicBoard = createQuery<
  GetResourceAgendaPublicBoard,
  GetResourceAgendaPublicBoardRequest,
  Error
>({
  queryKey: ["resourceAgendaPublicBoard"],
  retry: 0,
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    return api<
      GetResourceAgendaPublicBoardRequest,
      GetResourceAgendaPublicBoard
    >({
      method: "GET",
      url: `/public/:slug`,
      requestSchema: GetResourceAgendaPublicBoardRequestSchema,
      responseSchema: GetResourceAgendaPublicBoardSchema,
      body: variables
    });
  }
});
